import React from "react";
import { useTranslation } from "react-i18next";
import "./Kapis.scss";

function Kapis() {

  const { t } = useTranslation()

  return (
    <div className="container-Kapis">
      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.realtime_kpis.title")}</h1>
        <p>{t("scheduling.kpis.realtime_kpis.section_text")}</p>
      </div>
      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.alerts.title")}</h1>
        <p>{t("scheduling.kpis.alerts.section_text")}</p>
      </div>
      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.data.title")}</h1>
        <p>{t("scheduling.kpis.data.section_text_1")}</p>
        <p>{t("scheduling.kpis.data.section_text_2")}</p>
      </div>
      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.manage.title")}</h1>
        <p>{t("scheduling.kpis.manage.section_text")}</p>
      </div>

      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.data_automatization.title")}</h1>
        <p>{t("scheduling.kpis.data_automatization.section_text")}</p>
      </div>

      <div className="texts-Kapis">
        <h1>{t("scheduling.kpis.data_update.title")}</h1>
        <p>{t("scheduling.kpis.data_update.section_text")}</p>
      </div>
    </div>
  );
}

export default Kapis;
